import { render, staticRenderFns } from "./MetadadosFiltrosRecursivos.vue?vue&type=template&id=dc9f4b62"
import script from "./MetadadosFiltrosRecursivos.vue?vue&type=script&lang=js"
export * from "./MetadadosFiltrosRecursivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports